import React, { useEffect, useState } from 'react';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';
import { useNavigate, useParams } from 'react-router-dom';

const firebaseConfig = {
  apiKey: "AIzaSyDJ_lusSO40qPa2pKdvwOOexRPU2p4Vsro",
  authDomain: "tradeahv2.firebaseapp.com",
  projectId: "tradeahv2",
  storageBucket: "tradeahv2.firebasestorage.app",
  messagingSenderId: "398274404066",
  appId: "1:398274404066:web:74be764b202f62b91f08bb"
};

initializeApp(firebaseConfig);
const db = getFirestore();

export default function SignalDetailsPage() {
  const { id } = useParams();
  const [signal, setSignal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [symbolsMap, setSymbolsMap] = useState({});
  const navigate = useNavigate();

  // تحميل رموز TradingView
  useEffect(() => {
    const loadSymbols = async () => {
      try {
        const response = await fetch('/symbols.csv');
        const text = await response.text();
        const lines = text.split('\n').slice(1);
        const map = {};
        lines.forEach(line => {
          if (line.trim()) {
            const parts = line.split(',');
            if (parts.length >= 4) {
              const [symbol, market, name_ar, tradingview_symbol] = parts;
              map[symbol] = tradingview_symbol.trim();
            }
          }
        });
        setSymbolsMap(map);
      } catch (error) {
        console.error('Error loading symbols:', error);
      }
    };
    loadSymbols();
  }, []);

  // تحميل تفاصيل التوصية
  useEffect(() => {
    const fetchSignal = async () => {
      if (!id) {
        navigate('/archive');
        return;
      }
      
      try {
        const docRef = doc(db, 'signals_v2', id);
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          setSignal(docSnap.data());
        } else {
          navigate('/archive');
        }
      } catch (error) {
        console.error("Error fetching signal:", error);
        navigate('/archive');
      } finally {
        setLoading(false);
      }
    };
    
    fetchSignal();
  }, [id, navigate]);

  if (loading) {
    return (
      <div style={{ 
        padding: '20px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        minHeight: '50vh'
      }}>
        تحميل تفاصيل التوصية...
      </div>
    );
  }

  if (!signal) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        التوصية غير موجودة
      </div>
    );
  }

  // تحديد لون الحالة
  const statusColor = signal.status === 'achieved' ? '#16a34a' : 
                     signal.status === 'stopped' ? '#dc2626' : '#1e40af';
  const statusText = signal.status === 'achieved' ? 'ناجحة' : 
                    signal.status === 'stopped' ? 'خاسرة' : 'نشطة';

  return (
    <div style={{ padding: '20px', direction: 'ltr', fontFamily: 'Arial' }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '24px'
      }}>
        <h1 style={{ color: '#1e40af', margin: 0 }}>
          تفاصيل التوصية
        </h1>
        <button 
          onClick={() => window.history.back()}
          style={{
            backgroundColor: '#1e40af',
            color: 'white',
            border: 'none',
            padding: '8px 16px',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          العودة
        </button>
      </div>

      {/* معلومات أساسية */}
      <div style={{ 
        backgroundColor: 'white', 
        padding: '24px', 
        borderRadius: '16px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        marginBottom: '24px'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h2 style={{ margin: '0', color: '#0f172a', fontSize: '28px' }}>
              🟢 {signal.action} {signal.ticker}
            </h2>
            {signal.ticker_name && (
              <div style={{ fontSize: '18px', color: '#64748b', marginTop: '4px' }}>
                ({signal.ticker_name})
              </div>
            )}
          </div>
          <div style={{ 
            backgroundColor: statusColor + '20',
            color: statusColor,
            padding: '8px 16px',
            borderRadius: '20px',
            fontWeight: 'bold',
            fontSize: '16px'
          }}>
            {statusText}
          </div>
        </div>
        
        <div style={{ marginTop: '16px', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
          <div>
            <div style={{ fontSize: '14px', color: '#64748b' }}>الخبير</div>
            <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
              {signal.expert_id ? `TradeAH_${signal.expert_id.split('_').pop()}` : 'النظام'}
            </div>
          </div>
          <div>
            <div style={{ fontSize: '14px', color: '#64748b' }}>النوع</div>
            <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
              {signal.signal_type === 'intraday' ? 'إنتراداي' : 
               signal.signal_type === 'short' ? 'قصيرة' : 'متوسطة'}
            </div>
          </div>
          <div>
            <div style={{ fontSize: '14px', color: '#64748b' }}>الثقة</div>
            <div style={{ fontWeight: 'bold', fontSize: '16px', color: '#1e40af' }}>
              {signal.confidence_score}%
            </div>
          </div>
          <div>
            <div style={{ fontSize: '14px', color: '#64748b' }}>التاريخ</div>
            <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
              {signal.created_at?.toDate?.().toLocaleDateString('ar-EG') || 'غير معروف'}
            </div>
          </div>
        </div>
      </div>

      {/* التشارت */}
      <div style={{ 
        backgroundColor: 'white', 
        padding: '16px', 
        borderRadius: '16px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        marginBottom: '24px'
      }}>
        <h3 style={{ margin: '0 0 16px 0', color: '#1e40af', fontSize: '20px' }}>
          الرسم البياني
        </h3>
        <div style={{ height: '500px', borderRadius: '12px', overflow: 'hidden' }}>
          <iframe
            src={`https://s.tradingview.com/widgetembed/?symbol=${symbolsMap[signal.ticker] || signal.ticker}&interval=D&hidesidetoolbar=1&symboledit=0&saveimage=0&toolbarbg=F1F3F6&studies=[]`}
            width="100%"
            height="100%"
            style={{ border: 'none' }}
            title={`Chart for ${signal.ticker}`}
            loading="lazy"
          />
        </div>
      </div>

      {/* تفاصيل الأسعار */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', 
        gap: '24px'
      }}>
        <div style={{ 
          backgroundColor: 'white', 
          padding: '20px', 
          borderRadius: '16px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
          <h3 style={{ margin: '0 0 16px 0', color: '#1e40af', fontSize: '18px' }}>
            مستويات التداول
          </h3>
          <div style={{ display: 'grid', gap: '12px' }}>
            <div>
              <div style={{ fontSize: '14px', color: '#64748b' }}>سعر الدخول</div>
              <div style={{ fontWeight: 'bold', fontSize: '18px', color: '#1e40af' }}>
                {signal.entry_price}
              </div>
            </div>
            <div>
              <div style={{ fontSize: '14px', color: '#64748b' }}>الهدف</div>
              <div style={{ fontWeight: 'bold', fontSize: '18px', color: '#16a34a' }}>
                {signal.take_profit}
              </div>
            </div>
            <div>
              <div style={{ fontSize: '14px', color: '#64748b' }}>وقف الخسارة</div>
              <div style={{ fontWeight: 'bold', fontSize: '18px', color: '#dc2626' }}>
                {signal.stop_loss}
              </div>
            </div>
            {signal.closed_price && (
              <div>
                <div style={{ fontSize: '14px', color: '#64748b' }}>سعر الإغلاق</div>
                <div style={{ 
                  fontWeight: 'bold', 
                  fontSize: '18px', 
                  color: signal.status === 'achieved' ? '#16a34a' : '#dc2626'
                }}>
                  {signal.closed_price}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* أداء التوصية */}
        {(signal.status !== 'active' || signal.performance_note) && (
          <div style={{ 
            backgroundColor: 'white', 
            padding: '20px', 
            borderRadius: '16px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{ margin: '0 0 16px 0', color: '#1e40af', fontSize: '18px' }}>
              أداء التوصية
            </h3>
            {signal.closed_price && (
              <div style={{ marginBottom: '16px' }}>
                <div style={{ fontSize: '14px', color: '#64748b' }}>النتيجة</div>
                <div style={{ 
                  fontWeight: 'bold', 
                  fontSize: '18px',
                  color: signal.status === 'achieved' ? '#16a34a' : '#dc2626'
                }}>
                  {signal.status === 'achieved' ? 'ناجحة' : 'خاسرة'}
                </div>
              </div>
            )}
            {signal.performance_note && (
              <div>
                <div style={{ fontSize: '14px', color: '#64748b', marginBottom: '8px' }}>ملاحظة الأداء</div>
                <div style={{ 
                  backgroundColor: '#f1f5f9', 
                  padding: '12px', 
                  borderRadius: '8px',
                  fontSize: '15px',
                  color: '#334155'
                }}>
                  📝 {signal.performance_note}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}